function CallToAction({ className, showbtn = false }) {
  return (
    <div
      className={
        className +
        " px-[5rem] py-[2rem] flex justify-between items-center bg-linear-to-r from-[#dfe3fa] to-white rounded-2xl outline-2 outline-gray-200"
      }
    >
      <div className="text-[#525357] text-left">
        <p className="text-4xl/[1.25] font-semibold">Hi, Validator</p>
        <p className="text-xl">Ready to start your day?</p>
      </div>
      {showbtn && (
        <button className="bg-[#6f81f5] px-5 py-4 text-white rounded-xl text-lg">
          Start New Form →
        </button>
      )}
    </div>
  );
}

export default CallToAction;
